import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../context/NavigationContext';
import { ThemeContext } from '../context/ThemeContext';
import { useDemo } from '../context/DemoContext';
import '../styles/Footer.css';

function Footer() {
  const navigate = useNavigate();
  const { isTabActive, routes, setActiveTab } = useNavigation();
  const { theme } = useContext(ThemeContext);
  const { isDemoMode } = useDemo();

  const handleNav = (routeName) => () => {
    const path = routes[routeName.toUpperCase()]?.path || routes.FEED.path;
    
    // Simple navigation - let React Router handle everything
    navigate(path);
    
    // Only set active tab for main app routes, not auth routes
    if (['feed', 'discussions', 'profile', 'chats'].includes(routeName)) {
      setActiveTab(routeName);
    }
  };

  return (
      <footer className="App-footer">
          <div className="footer-icon-container" onClick={handleNav('feed')}>
              <img src={isTabActive('feed') ? routes.FEED.icon.active[theme] : routes.FEED.icon.inactive} alt="Feed" width="30" height="30" />
          </div>
          {!isDemoMode && (
              <div className="footer-icon-container" onClick={handleNav('discussions')}>
                  <img src={isTabActive('discussions') ? routes.DISCUSSIONS.icon.active[theme] : routes.DISCUSSIONS.icon.inactive} alt="Discussions" width="30" height="30" />
              </div>
          )}
          <div className="footer-icon-container" onClick={handleNav('profile')}>
              <img src={isTabActive('profile') ? routes.PROFILE.icon.active[theme] : routes.PROFILE.icon.inactive} alt="Profile" width="30" height="30" />
          </div>
    </footer>
  );
}

export default Footer;
